export default __webpack_public_path__ + "static/media/Logo-Circle.57276a1e.png";